var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "f-content-restrictions" }, [
    _c("label", [_vm._v(_vm._s(_vm.label))]),
    _c(
      "div",
      { staticClass: "input-wrapper" },
      [
        _c("w-switch", {
          attrs: { label: "Public" },
          on: { input: _vm.input },
          model: {
            value: _vm.restrictions.public,
            callback: function ($$v) {
              _vm.$set(_vm.restrictions, "public", $$v)
            },
            expression: "restrictions.public",
          },
        }),
        _c("w-switch", {
          attrs: { label: "Private", disabled: _vm.restrictions.public },
          on: { input: _vm.input },
          model: {
            value: _vm.restrictions.private,
            callback: function ($$v) {
              _vm.$set(_vm.restrictions, "private", $$v)
            },
            expression: "restrictions.private",
          },
        }),
        _c("w-switch", {
          attrs: { label: "Logged-in user", disabled: _vm.restrictions.public },
          on: { input: _vm.input },
          model: {
            value: _vm.restrictions.auth,
            callback: function ($$v) {
              _vm.$set(_vm.restrictions, "auth", $$v)
            },
            expression: "restrictions.auth",
          },
        }),
        _c("w-switch", {
          attrs: { label: "VIP members", disabled: _vm.restrictions.public },
          on: { input: _vm.input },
          model: {
            value: _vm.restrictions.members,
            callback: function ($$v) {
              _vm.$set(_vm.restrictions, "members", $$v)
            },
            expression: "restrictions.members",
          },
        }),
        _c("w-switch", {
          attrs: {
            label: "Premium members",
            disabled: _vm.restrictions.public,
          },
          on: { input: _vm.input },
          model: {
            value: _vm.restrictions.premium,
            callback: function ($$v) {
              _vm.$set(_vm.restrictions, "premium", $$v)
            },
            expression: "restrictions.premium",
          },
        }),
        _c("w-switch", {
          attrs: { label: "Pay-per-view", disabled: _vm.restrictions.public },
          on: { input: _vm.input },
          model: {
            value: _vm.restrictions.payperview,
            callback: function ($$v) {
              _vm.$set(_vm.restrictions, "payperview", $$v)
            },
            expression: "restrictions.payperview",
          },
        }),
        _c("f-users", {
          attrs: {
            value: _vm.restrictions.users,
            label: "Specific users",
            disabled: _vm.restrictions.public,
          },
          on: { input: _vm.updateUsers },
        }),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "extra" },
      [
        _c("label", [_vm._v("Related content")]),
        _c("div", { staticClass: "input-wrapper" }),
        _c("f-media", {
          attrs: {
            label: "Preview",
            single: true,
            disabled: _vm.restrictions.public,
          },
          on: { input: _vm.input },
          model: {
            value: _vm.restrictions.preview,
            callback: function ($$v) {
              _vm.$set(_vm.restrictions, "preview", $$v)
            },
            expression: "restrictions.preview",
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }